import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres7de/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres7de/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    let dteyear = ''
    dteyear = (typeof searchParams.year !== 'undefined' ? searchParams.year : '')
    sendParams = {
      p_codcours: (typeof searchParams.courstrain !== 'undefined' ? searchParams.courstrain : ''),
      p_numclseq: (typeof searchParams.numclseq !== 'undefined' ? searchParams.numclseq : ''),
      p_dtereq_st: (typeof searchParams.dtestrt !== 'undefined' ? searchParams.dtestrt : ''),
      p_dtereq_en: (typeof searchParams.dteend !== 'undefined' ? searchParams.dteend : '')
    }
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/hres7de/index/' + dteyear, { params: sendParams })
  },
  getDetail (searchParams) {
    let dataParams = {
      p_dteyear: searchParams.year,
      p_codcours: searchParams.codcours,
      p_numclseq: searchParams.numclseq
    }
    if (isMock) return generator(mocker.detail())
    const params = dataParams.p_dteyear + '/' + dataParams.p_codcours + '/' + dataParams.p_numclseq
    return instance().get(endpoint + '/hres7de/detail/' + params)
  },
  getDetailTab1Popup (detailTab1) {
    let sendParams = {}
    sendParams = {
      p_codexam: detailTab1.codexam
    }
    let param = detailTab1.codempid + '/' + detailTab1.dteexam.replace(/\//g, '')
    if (isMock) return generator(mocker.detailTab1Popup())
    return instance().get(endpoint + '/stdtrtest/index/' + param, { params: sendParams })
  },
  getDetailTab3Popup (searchParams) {
    let sendParams = {}
    sendParams = {
      p_codform: searchParams.p_codform
    }
    if (isMock) return generator(mocker.detailTab3Popup())
    let param = searchParams.p_dteyear + '/' + searchParams.p_codcours + '/' + searchParams.p_numclseq + '/' + searchParams.p_codinst + '/' + searchParams.p_codsubj
    return instance().get(endpoint + '/hres7de/detailPopupTab3/' + param, { params: sendParams })
  },
  postSaveDetailTab2 ({ codempid, searchIndex, indexSelected, detailTab2 }) {
    let sendParams = {
      param_json: JSON.stringify({
        codempid: codempid,
        dteyear: searchIndex.year,
        codcours: indexSelected.codcours,
        numclseq: indexSelected.numclseq,
        numtime: detailTab2.detail.numtime,
        detail: detailTab2.detail,
        table1: detailTab2.table1
      })
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres7de/detailTab2Save', sendParams)
  },
  postSaveDetailTab3 ({ codempid, searchIndex, indexSelected, detailTab3 }) {
    let sendParams = {
      param_json: JSON.stringify({
        codempid: codempid,
        dteyear: searchIndex.year,
        codcours: indexSelected.codcours,
        numclseq: indexSelected.numclseq,
        numtime: detailTab3.popup.detail.numtime,
        codinst: detailTab3.selected.codinst,
        codsubj: detailTab3.selected.codsubj,
        destrevl: detailTab3.selected.destrevl,
        detail: detailTab3.popup.detail,
        table1: detailTab3.popup.table1
      })
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres7de/detailTab3Save', sendParams)
  },
  postSaveDetailTab4 ({ searchIndex, detailTab4 }) {
    if (isMock) return generator(mocker.save())
    let sendParams = {
      param_json: JSON.stringify({
        p_dessummary: detailTab4.dessummary,
        p_desbenefit: detailTab4.desbenefit,
        p_descomment: detailTab4.descomment
      })
    }
    const param = searchIndex.year + '/' + detailTab4.codcours + '/' + detailTab4.numclseq
    return instance().post(endpoint + '/hres7de/detailTab4Save/' + param, sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres7de/index.js